import React, { Component, Fragment } from "react";
import ReactGA from "react-ga";
import NavBarComponent from "../../utilerias/nav";
import MenuComponent from "../../utilerias/menu";
import NosotrosComponent from "../componentes/nosotros";
import Manifiesto from "../../utilerias/español/manifiesto.json";
import ManifiestoEN from "../../utilerias/ingles/manifiestoEN.json";
import RedesComponent from "../../utilerias/redesSociales";
import $ from "jquery";
import "./styles.css";

export class Nosotros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guardarIdioma: "",
      guardarNuevoIdioma: true,
      idiomaNavegador: navigator.language || navigator.userLanguage,
      componente: "",
      statusMenu: false,
    };
  }

  UNSAFE_componentWillMount() {
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        this.setState({ guardarIdioma: ManifiestoEN });
        this.setState({ componente: "who is jack?" });
        this.setState({ guardarNuevoIdioma: false });
      } else {
        this.setState({ guardarIdioma: Manifiesto });
        this.setState({ componente: "¿quién es jack?" });
        this.setState({ guardarNuevoIdioma: true });
      }
    } else {
      if (storage !== null && storage === false) {
        this.setState({ guardarIdioma: Manifiesto });
        this.setState({ componente: "¿quién es jack?" });
        this.setState({ guardarNuevoIdioma: true });
      } else {
        this.setState({ guardarIdioma: ManifiestoEN });
        this.setState({ componente: "who is jack?" });
        this.setState({ guardarNuevoIdioma: false });
      }
    }
  }

  componentDidMount() {
    const video = document.getElementsByTagName("video");
    if (video[0] !== undefined) {
      $("video").prop('muted', true);
    }
    const separador = "-";
    const idiomaCadena = this.state.idiomaNavegador.split(separador);
    const storage = JSON.parse(localStorage.getItem("español"));
    if (idiomaCadena[0] === "es") {
      if (storage !== null && storage === true) {
        document.getElementById("text-lang").innerHTML = "ENG";
      } else {
        document.getElementById("text-lang").innerHTML = "ESP";
      }
    } else {
      if (storage !== null && storage === false) {
        document.getElementById("text-lang").innerHTML = "ESP";
      } else {
        document.getElementById("text-lang").innerHTML = "ENG";
      }
    }
  }
  render() {
    const openNav = () => {
      ReactGA.event({
        category: "Button",
        action: "Se ha dado click en el apartado del nav",
      });
      this.setState({ statusMenu: true });
      const x = window.matchMedia("(max-width: 999px)");
      if (x.matches === true) {
        document.getElementById("myNav").style.height = "110%";
      } else {
        document.getElementById("myNav").style.height = "100%";
      }
      document.getElementsByTagName("html")[0].style.overflowY = "hidden";
      document.getElementById("myNav").style.overflowY = "auto";
    };

    const closeNav = () => {
      this.setState({ statusMenu: false });
      document.getElementsByTagName("html")[0].style.overflowY = "visible";
      document.getElementById("myNav").style.height = "0%";
    };

    const cambiarIdioma = () => {
      if (this.state.guardarNuevoIdioma) {
        this.setState({ guardarIdioma: ManifiestoEN });
        this.setState({ guardarNuevoIdioma: false });
        this.setState({ componente: "who is jack?" });
        document.getElementById("text-lang").innerHTML = "ENG";
        localStorage.setItem("español", true);
      } else {
        this.setState({ guardarIdioma: Manifiesto });
        this.setState({ guardarNuevoIdioma: true });
        this.setState({ componente: "¿quién es jack?" });
        document.getElementById("text-lang").innerHTML = "ESP";
        localStorage.setItem("español", false);
      }
    };
    return (
      <Fragment>
        <div className="nosotros-fondo">
          <NavBarComponent
            closeNav={closeNav}
            openNav={openNav}
            statusMenu={this.state.statusMenu}
            cambiarIdioma={cambiarIdioma}></NavBarComponent>
          <MenuComponent
            closeNav={closeNav}
            cambiarIdioma={this.state.guardarNuevoIdioma}
          ></MenuComponent>
          <NosotrosComponent
            cambiarIdioma={this.state.guardarNuevoIdioma}
            componente={this.state.componente}
            manifiesto={this.state.guardarIdioma}
          ></NosotrosComponent>
          <div className="footer-redes-nosotros">
            <RedesComponent></RedesComponent>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Nosotros;
